import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CaseProvider } from "../../contexts/CaseContext";
import Cases from "./Cases";
import Create from "./Create";
import Wizard from "./bulk/Wizard";
import Dashboard from "./dashboard/Dashboard";
import Status from "./Status";
import Files from "./Files";
import RevisionsRouter from "./revisions/Router";

const Router: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Cases />} />
      <Route path="/create" element={<Create />} />
      <Route path="/create/bulk" element={<Wizard/>} />
      <Route
        path="/:id"
        element={<Navigate to="dashboard/overview" replace />}
      />
      <Route
        path="/:id/status"
        element={
          <CaseProvider>
            <Status />
          </CaseProvider>
        }
      />
      <Route
        path="/:id/dashboard/*"
        element={
          <CaseProvider>
            <Dashboard />
          </CaseProvider>
        }
      />
      <Route
        path="/:id/files"
        element={
          <CaseProvider>
            <Files />
          </CaseProvider>
        }
      />
      <Route
        path="/:id/revisions/*"
        element={
          <CaseProvider>
            <RevisionsRouter />
          </CaseProvider>
        }
      />
    </Routes>
  );
};

export default Router;
